// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"518629ef","66":"c8be82a6","749":"10e983d2","794":"721f92fe"}[chunkId] + ".chunk.js";
};